import {
   QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_LOWER_RANGE,
   QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_UPPER_RANGE,
} from 'constants/palletLogisticMinimums';
import { PalletType } from 'interfaces';

type PalletData = {
   name: PalletType;
   orderType: string;
   amount: string;
   logisticMinimum: number;
};

const PALLET_AMOUNT_ZERO_REMINDER = 0;

export const checkIfLogisticMinimumAchieved = (pallets: PalletData[]) => {
   const areAllPalletAmountsDefinedAsLogisticMinimums =
      checkIfAllPalletAmountsDefinedAsLogisticMinimums(pallets);
   if (areAllPalletAmountsDefinedAsLogisticMinimums) {
      return true;
   }
   const palletsWithCustomAmounts = pallets.filter(
      (pallet: PalletData) => pallet.orderType === 'CUSTOM',
   );
   const areAllPaletsCustomAmountsEqualLogisticMinimums =
      checkIfPaletsCustomAmountsEqualLogisticMinimums(palletsWithCustomAmounts);
   return areAllPaletsCustomAmountsEqualLogisticMinimums;
};

const checkIfAllPalletAmountsDefinedAsLogisticMinimums = (pallets: PalletData[]) =>
   pallets.every((pallet: PalletData) => pallet.orderType === 'LOGISTIC_MINIMUM');

const checkIfPaletsCustomAmountsEqualLogisticMinimums = (pallets: PalletData[]) =>
   pallets.every((pallet: PalletData) => {
      const parsedPalletAmount = parseInt(pallet.amount);
      if (pallet.name === 'QUARTER_PALLET_CDHP') {
         const isPalletAmountBelowLowerRange =
            parsedPalletAmount < QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_LOWER_RANGE;
         const isPalletAmountBelowUpperRange =
            parsedPalletAmount <= QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_UPPER_RANGE;
         const palletAmountAboveUpperLimit =
            parsedPalletAmount % QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_UPPER_RANGE;
         if (isPalletAmountBelowLowerRange) {
            return false;
         }
         if (isPalletAmountBelowUpperRange) {
            return true;
         }
         return (
            palletAmountAboveUpperLimit === PALLET_AMOUNT_ZERO_REMINDER ||
            palletAmountAboveUpperLimit >= QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_LOWER_RANGE
         );
      } else {
         return parsedPalletAmount % pallet.logisticMinimum === PALLET_AMOUNT_ZERO_REMINDER;
      }
   });
